export class RequestUserSummaryModel {
    class: string;
    fetchCriteria: {};
    licenseStatus: string;
    employeeClientIdList: any[];

    constructor() {
        this.class = 'API::BrokerLicenseCriteria';
        this.licenseStatus = 'ASSIGNED';
        this.fetchCriteria = {};
        this.employeeClientIdList = [];
    }
}
